export default {
  Feature: "Feature",
  AddFeature: "AddFeature",
  editFeature: "EditFeature",
};
